import React from 'react';
import styled from 'styled-components';
import {LiveShoppingHeader} from '../../../../../grpc_client/grips/protos/pages/v1/live_shopping';
import Icon, {IconSize} from '../../../../../ui/Icon/Icon';
import {LiveShopping} from '../../../../../ui/Icon/IconName';
import {mediaMinTablet} from '../../../../../ui/constants/customMedia';
import {
  fontSize16,
  fontSize32,
  fontSize48,
  fwHeavy,
  lhM,
} from '../../../../../ui/constants/typography';
import {cdnImageUrl} from '../../../../../utils/cdnImageUrl';

export const LiveHeader: React.FC<{
  header: LiveShoppingHeader | undefined;
}> = ({header}) => {
  if (!header) {
    return null;
  }

  const {imageHash, title, subtitle} = header;
  const backgroundImageUrl = cdnImageUrl(imageHash);

  return (
    <LiveShoppingHeaderContainer backgroundImageUrl={backgroundImageUrl}>
      <StyledIcon asset={LiveShopping.IcLiveShopping} size={IconSize.XL} />
      <Title>{title}</Title>
      <SubTitle>{subtitle}</SubTitle>
    </LiveShoppingHeaderContainer>
  );
};

const LiveShoppingHeaderContainer = styled.header<{
  backgroundImageUrl: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${props => props.backgroundImageUrl});
  height: 310px;
`;

const StyledIcon = styled(Icon)`
  margin-top: 70px;
`;

const Title = styled.h1`
  ${fontSize32};
  ${fwHeavy};
  line-height: ${lhM};
  margin-top: 9px;
  margin-bottom: 0;
  color: currentColor;
  text-align: center;
  @media ${mediaMinTablet} {
    ${fontSize48};
  }
`;

const SubTitle = styled.div`
  ${fontSize16};
  ${fwHeavy};
  line-height: ${lhM};
  margin-top: 15px;
  color: currentColor;
  text-align: center;
  @media ${mediaMinTablet} {
    ${fontSize32};
  }
`;
